import { FormattedMessage } from 'react-intl';
import { IconWarningTriangle } from '@/icons';
import { cn } from '@/helpers/classnames';

interface NoClaimWarningProps {
  categoryName?: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
  canCreate?: boolean;
}

export const NoClaimWarning = ({
  categoryName,
  className,
  action,
  canCreate = true,
}: NoClaimWarningProps) => {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-3 rounded-md border border-yellow-600 bg-yellow-50 p-4',
        className,
      )}
    >
      <IconWarningTriangle
        className="mt-0.5 size-5 min-w-5 text-yellow-600"
        aria-hidden="true"
      />
      <div className="flex-1">
        <p className="font-medium text-yellow-900">
          {!!categoryName && `${categoryName}: `}
          <FormattedMessage defaultMessage="Ingen aktiv eller kommande period" />
        </p>
        <p className="mt-1 text-yellow-900">
          {canCreate ? (
            <FormattedMessage defaultMessage="Det finns ingen period som ger eleverna biljetter just nu eller framöver. Skapa en ny period för att säkerställa att eleverna får sina biljetter." />
          ) : (
            <FormattedMessage defaultMessage="Det finns ingen period som ger eleverna biljetter just nu eller framöver." />
          )}
        </p>
        {action && <div className="mt-2">{action}</div>}
      </div>
    </div>
  );
};
